module.exports =  require('./lib/mediaquery');




//////////////////
// WEBPACK FOOTER
// ./node_modules/mediaquery/index.js
// module id = 725
// module chunks = 2